'use client';

import { motion } from 'framer-motion';
import { Sparkle } from 'lucide-react';
import Image from 'next/image';

import { DownloadPreviewImage, DownloadQr } from '@/assets';
import AppStore from '@/components/widgets/AppStore';
import GooglePlay from '@/components/widgets/GooglePlay';

export const DownloadSection = () => {
  return (
    <>
      <section id="download" className="section">
        <div className="container mx-auto px-4">
          <motion.div
            className="relative overflow-hidden rounded-xl bg-gradient-to-tr from-primary-600 to-primary-300 shadow-xl"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            whileHover={{ y: -5 }}
          >
            {/* Decorative shapes */}
            <motion.div
              className="absolute -right-16 -top-16 size-64 rounded-full bg-primary-200 opacity-20"
              animate={{
                scale: [1, 1.1, 1],
                rotate: [0, 5, 0],
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                repeatType: 'reverse',
              }}
            />
            <motion.div
              className="absolute -bottom-20 -left-20 size-72 rounded-full bg-primary-200 opacity-20"
              animate={{
                scale: [1, 1.2, 1],
                rotate: [0, -5, 0],
              }}
              transition={{
                duration: 10,
                repeat: Infinity,
                repeatType: 'reverse',
              }}
            />

            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2">
              <div className="flex items-center p-8 lg:p-12">
                <div className="w-full text-white">
                  <motion.h2
                    className="mb-4 text-white"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    Miễn phí 3 tháng, trải nghiệm ngay!
                  </motion.h2>
                  <motion.div
                    className="mb-8"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, ease: 'easeOut' }}
                  >
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.7, duration: 0.5 }}
                    >
                      <p className="text-base text-white md:text-lg">
                        Tải xuống ngay để trở thành chủ quán 4.0 với toàn bộ
                        tính năng cùng Zump
                      </p>
                    </motion.div>
                  </motion.div>
                  <motion.div
                    className="flex items-center justify-center gap-4 lg:justify-start"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                  >
                    <div className="relative size-28 md:size-32 lg:size-36">
                      <Image
                        src={DownloadQr}
                        alt="QR Code"
                        fill
                        className="rounded-lg"
                      />
                    </div>
                    <div className="flex flex-col gap-4">
                      <AppStore />
                      <GooglePlay />
                    </div>
                  </motion.div>
                  <motion.div
                    className="mt-8 text-gray-50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                  >
                    <div className="flex items-center justify-center gap-2 text-primary-500 lg:justify-start">
                      <p className="text-white">
                        <Sparkle className="mr-2 inline size-4 text-white" />
                        Áp dụng cho khách hàng mới đăng ký
                      </p>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-primary-500 lg:justify-start">
                      <p className="text-white">
                        <Sparkle className="mr-2 inline size-4 text-white" />
                        Không cần thẻ tín dụng
                      </p>
                    </div>
                  </motion.div>
                </div>
              </div>
              <div className="relative overflow-hidden lg:h-auto">
                <motion.div
                  className="flex size-full items-center justify-center"
                  animate={{ y: [0, -10, 0] }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    repeatType: 'reverse',
                  }}
                >
                  <Image
                    src={DownloadPreviewImage}
                    alt="App Preview"
                    className="object-cover"
                  />
                </motion.div>

                <motion.div
                  className="absolute right-10 top-10 rounded-lg bg-white p-3 shadow-lg"
                  animate={{
                    y: [0, 5, 0],
                    x: [0, 3, 0],
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    repeatType: 'reverse',
                  }}
                >
                  <p className="text-sm font-bold text-primary-600">
                    Không lo thất thoát
                  </p>
                </motion.div>

                <motion.div
                  className="absolute bottom-10 left-10 rounded-lg bg-white p-3 shadow-lg"
                  animate={{
                    y: [0, -5, 0],
                    x: [0, -3, 0],
                  }}
                  transition={{
                    duration: 3.5,
                    repeat: Infinity,
                    repeatType: 'reverse',
                  }}
                >
                  <p className="text-sm font-bold text-primary-600">
                    Quản lý dễ dàng
                  </p>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};
